import utils from '@2l/utils';

const { G } = utils;

export default {
  getCustomerEmail: G('email')
};
